<template>
  <div class="EyedropperBox" v-show="isShow" @click.stop @mousedown="$bus.emit('eyedropperBox.hide')">
    <div class="EyedropperBox__img-wrapper" ref="imgWrapper" @mousedown.stop>
      <img :src="imgSrc" alt :draggable="false" ref="imgEl" @load="setCanvas" />
      <canvas
        class="EyedropperBox__canvas"
        ref="canvasEl"
        @mousedown="setMousedown($event);pickColor($event)"
        @mousemove="pickColor($event)"
        @mouseleave="setMousedown($event)"
        @mouseup="setMousedown($event)"
        v-show="isShowCanvas"
      ></canvas>
      <div class="EyedropperBox__tip" v-show="isShowTip" :style="tipStyle" ref="tipEl" @click.stop>
        <span v-if="isShowRGBText" class="EyedropperBox__tip-text">{{tipText}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import getCanvasPixelColor from "@/plugins/get-canvas-pixel-color";
import { mapGetters } from "vuex";
import domToImage from "@/plugins/dom-to-image";
import snap from "@/components/mixins/snap";

export default {
  mixins: [snap],
  data() {
    return {
      isShow: false,
      imgSrc: "",
      isMousedown: false,
      isShowCanvas: false,
      readyStatus: "preparing",

      isShowTip: false,
      tipStyle: {},
      tipText: "",
      isShowRGBText: false,

      tids: []
    };
  },
  computed: {
    ...mapGetters(["TOOL", "Tool_Size", "TopNav_Size", "MaterialPane_Size"])
  },
  created() {
    this.$bus.on("eyedropperBox.addImage", ({ dataUrl, domRect } = {}) => {
      this.imgSrc = dataUrl;
      if (this.$refs.imgWrapper) {
        this.$refs.imgWrapper.style.cssText = `
          left: ${domRect.left}px;
          top: ${domRect.top}px;`;
      }
    });
    this.$bus.on("eyedropperBox.hide", () => {
      this.isShow = false;
      this.retrieveTipEl();
      this.toggleTip(false);
    });
    this.$bus.on("eyedropperBox.show", () => {
      this.setPreparing();
      this.imgSrc = "";
      this.isShowCanvas = false;
      this.isShow = true;
    });
    this.$bus.on("eyedropperStart", () => {
      this.$bus.emit("eyedropperBox.show");
      this.onEyedropperStart();
    });
  },
  methods: {
    async onEyedropperStart() {
      this.$bus.emit("eyedropperBox.show");

      await this.TOOL.setOption({
        width: this.Tool_Size.width,
        height: this.Tool_Size.height - 40,
        scale: 1,
        surplusY: this.TopNav_Size.height + 40,
        surplusX: this.MaterialPane_Size.width
      });

      // if (this.TOOL.selectedScenes.element.content.find('.mask-blur>video').length > 0) {
      await this.beforeGetSnap({
        palyerScene: this.TOOL.selectedScenes.element.content[0],
        scene: this.TOOL.selectedScenes,
        isPlayerLayer: false
      });
      // }
      // let dom = document.querySelector('#app>.Tool .scroll-visible');
      let dom = this.TOOL.selectedScenes.element.content[0];
      let domRect = dom.getBoundingClientRect();
      domToImage
        .toPng(dom, {
          style: {
            overflow: "hidden"
          },
          _width: domRect.width,
          _height: domRect.height,
          width: domRect.width,
          height: domRect.height,
          // filter: node => node.tagName !== 'VIDEO'
          filter: node => {
            let notVideo = node.tagName !== "VIDEO";
            let isImg = node.tagName === "IMG";
            let hasSpecial =
              node.classList &&
              (node.classList.contains("frame-image") ||
                node.classList.contains("_my-hand-player-svg"));
            if (hasSpecial) {
              return false;
            }
            if (isImg) {
              return node.src && node.src.length > 0;
            } else {
              return notVideo;
            }
          }
        })
        .then(dataUrl => {
          this.$bus.emit("eyedropperBox.addImage", { dataUrl, domRect });
        })
        .finally(() => {
          this.TOOL.sprites.forEach(scene => {
            scene.sprites.forEach(sprite => {
              if (sprite.type === 'Video') {
                const ele = document.getElementById('sprite-' + sprite.id);
                ele.style.backgroundImage = ''
                const playerEle = document.getElementById('player-sprite-' + sprite.id);
                playerEle.style.backgroundImage = ''
              }
            })
          });
        })
    },
    hideBox() {
      this.$bus.emit("eyedropperBox.hide");
    },
    setCanvas({ imgEl } = {}) {
      imgEl = imgEl || this.$refs.imgEl;
      console.log("imgEl---->", imgEl);
      if (!imgEl) {
        return;
      }
      let canvas = this.$refs.canvasEl;
      canvas.width = imgEl.naturalWidth;
      canvas.height = imgEl.naturalHeight;
      let ctx = canvas.getContext("2d");
      ctx.drawImage(imgEl, 0, 0, canvas.width, canvas.height);
      this.isShowCanvas = true;
      this.setReady();
    },
    pickColor(ev) {
      if (this.readyStatus !== "ready") {
        return;
      }
      // console.log({isMousedown: this.isMousedown})

      // 按下鼠标键才看到变色
      // if (ev.type === 'mousemove' && !this.isMousedown) {
      //   return;
      // }

      // mousemove就能看到变色
      let isChangeColorPickerInput = false;
      if (ev.type === "mousedown") {
        isChangeColorPickerInput = true;
        this.toggleTip(false);
        this.retrieveTipEl();
      }

      let rect = ev.target.getBoundingClientRect();
      let x = ev.clientX - rect.left;
      let y = ev.clientY - rect.top;
      let data = getCanvasPixelColor(this.$refs.canvasEl, x, y);
      this.$bus.emit("eyedropper.sendData", data, {
        isInputColor: isChangeColorPickerInput
      });

      if (ev.type === "mousemove") {
        let { rgb } = data;
        this.updateTip({
          color: rgb
        });
        if (this.$refs.imgWrapper.contains(this.$refs.tipEl)) {
          this.sendTipEl();
        }
        this.setTipPosition({
          event: ev
        }).then(this.toggleTip);
      }
    },

    // 按下鼠标键才看到变色
    setMousedown(ev) {
      if (ev.type === "mousedown") {
        this.isMousedown = true;
      } else if (ev.type !== "mousemove") {
        this.isMousedown = false;
      }
    },

    setPreparing() {
      this.readyStatus = "preparing";
      this.$bus.emit("eyedropperBox.prepareStart");
    },

    setReady() {
      this.readyStatus = "ready";
      this.$bus.emit("eyedropperBox.ready");
    },

    toggleTip(flag) {
      if (flag === false && this.isShowTip) {
        this.isShowTip = false;
        return;
      }

      if (!this.isShowTip) {
        this.isShowTip = true;
      }
    },

    updateTip({ color } = {}) {
      this.tipStyle = {
        ...this.tipStyle,
        backgroundColor: color
      };
      this.tipText = color;
    },

    setTipPosition({ event } = {}) {
      return new Promise((resolve, reject) => {
        // this.lastTime = Date.now();
        this.tids[this.tids.length] = setTimeout(() => {
          // if (Date.now() - this.lastTime < 1000 / 60) {
          //   resolve();
          //   return;
          // }
          this.tipStyle = {
            ...this.tipStyle,
            position: "fixed",
            top: `${event.clientY - 50}px`,
            left: `${event.clientX + 50}px`,
            zIndex: 20
          };
          this.tids.forEach(tid => {
            clearTimeout(tid);
          });
          this.tids = [];
          resolve();
        }, 1000 / 200);
      });
    },

    sendTipEl() {
      document.body.appendChild(this.$refs.tipEl);
    },

    retrieveTipEl() {
       this.$refs.imgWrapper && this.$refs.imgWrapper.appendChild(this.$refs.tipEl);
    }
  }
};
</script>

<style lang="scss" scoped>
.EyedropperBox {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 15;
  width: 100%;
  height: 100%;
  // background-color: rgba(#ffffff, 0.5)

  &__img-wrapper {
    position: absolute;
    $path: "../../static/animengine/img/";
    $file: "icon-eyedropper.cur";
    cursor: url(#{$path}#{$file}), auto;
  }

  &__canvas {
    position: absolute;
    top: 0;
    left: 0;
  }

  &__tip {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 50%;
    width: 74px;
    height: 74px;
    box-shadow: 0px 0px 0px 4px #bfc7e0;
  }

  &__tip-text {
    position: absolute;
    top: 108%;
    left: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EyedropperBox.vue